import { create } from 'zustand'

import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client'

export type Client = ApolloClient<NormalizedCacheObject>

type State = {
  // @DEPRECATED in favor of useApi+hooks+react-query
  client: Client | null
}

type Actions = {
  setClient: (client: Client) => void
  reset: () => void
}

export const useApiState = create<State & Actions>((set) => {
  return {
    client: null,

    setClient(client) {
      set({ client })
    },

    reset() {
      set({ client: null })
    },
  }
})
